import React from "react";
import { Button, Column, Modal, Row, Text } from "@amzn/meridian";

interface DuplicateBarcodeAlertModalProps {
  open: boolean;
  barcode: string;
  onClose: () => void;
}

const DuplicateBarcodeAlertModal: React.FC<DuplicateBarcodeAlertModalProps> = ({
  open,
  barcode,
  onClose,
}) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Column spacing="400" spacingInset="500">
        <Column spacing="300" alignmentHorizontal="center">
          <Text type="h300" alignment="center">
            Container Already Scanned
          </Text>
          <Text alignment="center" color="secondary">
            The barcode "{barcode}" has already been scanned in this inspection session.
          </Text>
          <Text alignment="center" color="secondary">
            Please scan a different container.
          </Text>
        </Column>
        <Row alignmentHorizontal="center" spacingInset="400 none none">
          <Button onClick={onClose}>
            Scan Again
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default DuplicateBarcodeAlertModal;
